// extracted by mini-css-extract-plugin
module.exports = {"footer_design":"CatValueCard_footer_design__u8m1K","cat_value_card":"CatValueCard_cat_value_card__CAWv6","arrow_upward":"CatValueCard_arrow_upward__amlw3"};